export default "__VITE_ASSET__6CdIjMcM__"